import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../../axios';
import { moduleName } from '../../moduleInfo';
import { affiliateConvertedLeadRoute } from '../../utils/apiRoutes';

export const getConvertedLeadsAsync = createAsyncThunk(
  `${moduleName}/getConvertedLeadsAsync`,
  async (payload) => {
    const { params } = payload;
    const response = await axios({
      method: 'GET',
      url: affiliateConvertedLeadRoute(),
      params: { ...params },
    });
    const data = response.data;
    return data;
  }
);

const ConvertedSlice = createSlice({
  name: `${moduleName}/convleads`,
  initialState: {
    loading: false,
    convertedReffer: [],
  },
  reducers: {},
  extraReducers: {
    [getConvertedLeadsAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getConvertedLeadsAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.convertedReffer = action.payload;
    },
    [getConvertedLeadsAsync.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

export default ConvertedSlice.reducer;
